import Resource from '../../resource';
import request from '../../../utils/request';
import { data } from 'jquery';

class Exams extends Resource {
    constructor() {
        super('exams');
    }

    lookups() {
        return request({
            url: `/exams/lookups`,
            method: 'get'
        });
    }

    export(data) {
        return request({
            url: `/exams/export`,
            method: 'post',
            data:data
        });
    }


}

export {Exams as default};
